import setTargetLinks from './targetLinks';

export default (element, isFramedMode) => {
  if (element && element.innerHTML) {
    setTargetLinks(element, isFramedMode);

    // Execute any scripts that came through innerHTML
    const dom = $(element.innerHTML);
    dom.filter('script').each(() => {
      $.globalEval(this.text || this.textContent || this.innerHTML || '');
    });
  }
};
